export const styles = {
  forgotPassword: {
    textAlign: 'right',
    marginBottom: '20px',
    '& a': {
      textDecoration: 'underline',
      color: '#1D2943',
      fontSize: 14,
    },
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
  },
}
